(function() {
    'use strict';

    angular.module('app.layout', [
        'app.core',
        'app.overlay'
    ]);
})();
